<template>
  <section
    class="hero jumbotron"
    :class="[this.alignment, { 'is-fullheight-with-navbar is-fullheight-with-spaced-navbar': !(this.uid == 'about' && this.index != 0) }]">
    <div class="hero-body">
      <div class="container">
        <div class="columns is-vcentered is-variable is-8" :class="[{ 'is-reverse': this.alignment == 'right'}]">
          <div v-scroll-reveal="{ delay: 30, origin: `${slice.primary.orientation == 'Left-aligned' ? 'left' : 'right'}` }" 
          class="column load-hidden is-half">
            <h1 :key="0" class="title">{{ $prismic.richTextAsPlain(slice.primary.hero_headline) }}</h1>
            <prismic-rich-text :field="slice.primary.hero_content"/>
          </div>
          <div class="column is-half graphics-column">
            <about-graphic v-if="this.uid == 'about' && this.index == 0" />
            <about-graphic-two v-else-if="this.uid == 'about' && this.index != 0" />
            <services-graphic v-else-if="this.uid == 'services'"/>
            <prismic-image v-else :field="slice.primary.hero_image"/>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import AboutGraphic from '../AboutGraphic.vue'
import AboutGraphicTwo from '../AboutGraphicTwo.vue'
import ServicesGraphic from '../ServicesGraphic.vue'

export default {
  name: "Hero",
  props: ["slice", "uid", "index"],
  components: {
    AboutGraphic,
    AboutGraphicTwo,
    ServicesGraphic
  },
  data () {
    return {
      alignment: 'left'
    }
  },
  created () {
    this.alignment = (this.slice.primary.orientation == 'Right-aligned' ? 'right' : 'left');
  },
};
</script>

<style lang="scss" scoped>
@import "~bulma/sass/utilities/_all";
@import "../../assets/sass/colors.scss";

.hero.jumbotron {
  background-position: 0% center;
  background-size: 40%;
  background-repeat: no-repeat;
  position: relative;
  &.left {
    background-position: 100% center;
  }
  &.right {
    background-position: 0% center;
  }
  @media screen and (max-width: $tablet) {
    background-image: none !important;
  }
}

.graphics-column {
  text-align: center;
}

.columns {
  &.is-reverse {
    flex-direction: row-reverse;
  }
}

/* Enter and leave animations can use different */
/* durations and timing functions.              */
.slide-fade-enter-active {
  transition: all 0.3s ease;
}
.slide-fade-leave-active {
  transition: all 0.8s cubic-bezier(1, 0.5, 0.8, 1);
}
.slide-fade-enter, .slide-fade-leave-to
/* .slide-fade-leave-active below version 2.1.8 */ {
  transform: translateX(10px);
  opacity: 0;
}
</style>
